import React, { useMemo } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Box, Button, Chip, Theme, useMediaQuery } from '@mui/material'
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { URL_APP, URL_HOME } from 'helpers/config'
import OrAuthSection from '../login/OrAuthSection'
import AuthWithGoogleButton from '../login/buttons/AuthWithGoogleButton'
import SignUpForm from './SignUpForm'
import images from 'assets/images'

const SignUpBuyerOptions = () => {
  const { productId } = useParams()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const [showAllOptions, setShowAllOptions] = React.useState(false)

  const loginLink = useMemo(() => {
    const { searchParams } = new URL(window.location.href)
    if (productId) searchParams.set('redirectUrl', `${URL_APP}/subscribe/${productId}?${searchParams.toString()}`)
    return `/login?${searchParams.toString()}`
  }, [productId])

  return (
    <Box p="24px" textAlign="center" width="100%" maxWidth="350px" mx="auto">
      {isMobile && <img src={images.LOGO_NN_BLUE} alt="logo nachonacho" style={{ width: 290 }} />}
      <Chip
        size="small"
        sx={{ bgcolor: 'var(--dark-blue)', mt: '10px', px: '10px', '& > span': { color: 'white' } }}
        label="Buyer Account"
      />
      <div style={{ height: 40 }} />

      <AuthWithGoogleButton textButton="Sign Up with Google" typeCreationApp="SIGN_UP" />

      <Box height="12px" />

      <Box>
        <span className="fs-14">
          Already have an account?{' '}
          <Link to={loginLink} className="link">
            Login
          </Link>
        </span>
      </Box>

      <OrAuthSection />

      {!showAllOptions && (
        <Button id="btn-signup-options" onClick={() => setShowAllOptions(true)}>
          <span className="fs-14 text-blue">
            Other sign up options <ExpandMoreIcon className="blue" sx={{ mb: '-8px' }} />
          </span>
        </Button>
      )}

      {showAllOptions && (
        <Box>
          <Button id="btn-signup-options" onClick={() => setShowAllOptions(false)}>
            <span className="fs-14 text-blue">
              Hide other sign up options <ExpandLessIcon className="blue" sx={{ mb: '-8px' }} />
            </span>
          </Button>

          <Box height="16px" />

          <SignUpForm />
        </Box>
      )}

      <Box maxWidth="265px" mx="auto" mt="24px">
        <span className="fs-14">
          By signing up, you agree to NachoNacho's{' '}
          <a href={`${URL_HOME}/terms-of-use`} className="link">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href={`${URL_HOME}/privacy-policy`} className="link">
            Privacy Policy
          </a>
        </span>
      </Box>
    </Box>
  )
}

export default SignUpBuyerOptions
